import React from 'react';
import { Route, Switch, useRouteMatch, useLocation, Redirect } from 'react-router-dom';

import useClassy from '@core/hooks/useClassy';
import { useProjectStore } from '@core/store';

import Segment, { SegmentItem } from '@ui/Segment';

import CustomCss from './Css';
import CustomHtml from './Html';
import classes from './index.module.scss';
import CustomJs from './Js';

export default function CustomCode() {
  const planFeatures = useProjectStore(s => s.plan.features);
  const bem = useClassy(classes, 'CustomCode');
  const { path } = useRouteMatch();
  const location = useLocation();

  const isCss = location.pathname.includes('/css');
  const isJs = location.pathname.includes('/js');
  const isHtml = location.pathname.includes('/html');

  const selectedIndex = isCss ? 0 : isJs ? 1 : isHtml ? 2 : undefined;

  return (
    <div className={bem('&')}>
      <Segment className={bem('-segment')} selectedIndex={selectedIndex} underline>
        <SegmentItem to="/appearance/custom-code/css">CSS</SegmentItem>
        <SegmentItem to="/appearance/custom-code/js">JS</SegmentItem>
        <SegmentItem to="/appearance/custom-code/html">HTML</SegmentItem>
      </Segment>
      <Switch>
        <Route exact path={`${path}/`}>
          <Redirect to="/appearance/custom-code/css" />
        </Route>
        <Route path={`${path}/css`}>
          <CustomCss />
        </Route>
        <Route path={`${path}/js`}>
          <CustomJs customFormGate={planFeatures.javascript ? 'none' : 'demo'} />
        </Route>
        <Route path={`${path}/html`}>
          <CustomHtml />
        </Route>
      </Switch>
    </div>
  );
}
